enum TrucklaneStatus {
  active = 'Active',
  inactive = 'Inactive',
}

export default TrucklaneStatus;
